import { BrowserRouter, Route, Switch } from 'inferno-router';
import React from 'react';
import { createElement } from 'inferno-compat';
import { StyleSheet, View } from './components/base_components';

import ModalDialog from './components/dialogs/modal_dialog';
import MenuOverlay from './components/overlays/menu_overlay';

import AccountScreen from './account_screen';
import DankCoinScreen from './dank_coin_screen';
import FBLoginComplete from './fb_login_complete';
import HomeScreen from './home_screen';
import GameListScreen from './game_list_screen';
import PrizeListScreen from './prize_list_screen';
import NotFoundScreen from './not_found_screen';
import LoginScreen from './login_screen';
import CryptoScreen from './crypto_screen';

import PromoAbridgedScreen from './components/promos/promo_abridged_screen';

const styles = StyleSheet.create({
  app: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  menuButton: {
    position: 'absolute',
    top: '1em',
    left: '1em',
    width: '3em',
    height: '3em',
  },
  text: {
    color: 'white',
    fontSize: '2em',
  },
});

type Props = {};
type State = {};

export default class App extends React.PureComponent<Props, State> {
  componentDidMount() {
    window.addEventListener('focus', _onFocus);
    window.addEventListener('blur', _onBlur);
  }
  componentWillUnmount() {
    window.removeEventListener('focus', _onFocus);
    window.removeEventListener('blur', _onBlur);
  }

  render() {
    return (
      <View style={styles.app}>
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={HomeScreen} />
            <Route exact path='/login' component={LoginScreen} />
            <Route
              exact
              path='/fb_login_complete'
              component={FBLoginComplete}
            />
            <Route exact path='/account' component={AccountScreen} />
            <Route
              path='/games/:game_name'
              component={_keyedParam(GameListScreen, 'game_name')}
            />
            <Route exact path='/games' component={GameListScreen} />
            <Route exact path='/prizes' component={PrizeListScreen} />
            <Route exact path='/dankcoin' component={DankCoinScreen} />
            <Route exact path='/crypto' component={CryptoScreen} />
            <Route exact path='/abridged' component={PromoAbridgedScreen} />
            <Route path='*' component={NotFoundScreen} />
          </Switch>
          <MenuOverlay />
        </BrowserRouter>
        <ModalDialog />
      </View>
    );
  }
}

function _onFocus() {
  window.document.body.classList.remove('doc-blur');
}
function _onBlur() {
  window.document.body.classList.add('doc-blur');
}

function _keyedParam(component, key) {
  return function(props) {
    props.key = props.match.params[key];
    return createElement(component, props);
  };
}
